<template>
  <el-dialog
    title="選擇語言"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
    class="dialogEdit"
  >
    <el-form :model="form" label-width="80px">
      <el-radio-group v-model="form.language">
        <el-radio :label="tw">繁</el-radio>
        <el-radio :label="cn">簡</el-radio>
        <el-radio :label="en">英</el-radio>
      </el-radio-group>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "language_dialog",
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: 30,
      form: {
        id: 0,
        language: 'tw'
      }
    };
  },

  methods: {
    show(value) {
      this.dialogVisible = true;
      var self = this;
      this.form = { id: value, language: 'tw' };
    },

    onSubmit() {
      var self = this;
      let params = Object.assign({}, this.form);
      self.$router.push({path:'/reptile/edit/' + this.form.id + '?language=' + this.form.language});
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="less">
.dialogEdit {
  text-align: left;
}
</style>